import { useEffect, useRef, useState } from 'react';

/**
 * Hook que permite detectar cuando se hace click fuera de un elemento para ocultar un componente.
 * Mantiene un estado, y cuando se hace click fuera del componente referenciado, el estado se vuelve false
 * @param initialVisible visibilidad inicial
 */
export function useComponentVisible(initialVisible: boolean) {
  const [isComponentVisible, setIsComponentVisible] = useState(initialVisible);
  const ref = useRef(null);
  useEffect(() => {
    function handleClickOutsideElem(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsComponentVisible(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutsideElem);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutsideElem);
    };
  }, [ref]);

  return { ref, isComponentVisible, setIsComponentVisible };
}
